export default __webpack_public_path__ + "static/media/cert.1d0cfa60.svg";